// CardSection.js
import React from 'react';
import {CardElement} from 'react-stripe-elements';

class CardSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        cardElement : null,
        clientSecret : null   
    }
  }  
  handleReady = element => {
    this.setState({ cardElement: element });
  };
    
  render() {
    return (
      <label>
        Card details
        <CardElement onReady={this.handleReady} style={{base: {fontSize: '14px'}}} hidePostalCode={true} />
      </label>
    );
  }
}

export default CardSection;